<template>
  <main style="
    background: rgb(241, 245, 244);
    display: flex;
    flex-direction: column;
    position: absolute;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center">
    <dr-icon name="maintenance" style="width: 100px" fill="blue"></dr-icon>
    <p class="text-center" style="font-size: 1.5em">
      <br />
      <strong>
        Estamos em manutenção.<br />
        Volte em alguns minutos e tente novamente.
      </strong>
    </p>
  </main>
</template>

<script>
export default {
  mounted () {
    this.fn_HIDE_PROGRESS()
  }
}
</script>
